export default __webpack_public_path__ + "967c78063f367ecd5f024c43e4f9bde6.png";